const reducer = state => ({
  ...state,
  waiting: true,
});

export default reducer;
